import { useIntl } from '@capsicum/common';
import { Button, Reversible } from '@capsicum/common-web';
import { ChevronLeftBoldIcon } from '@capsicum/common-web/icons';
import { type FC, type PropsWithChildren } from 'react';
import styled from 'styled-components';

import * as Components from './components.styled';

export const Shell: FC<
	PropsWithChildren<
		{ goBack: () => void } & (
			| {
					cta: JSX.Element;
			  }
			| {
					cta?: undefined;
					proceed: () => void;
			  }
		)
	>
> = props => {
	const { $t } = useIntl();

	return (
		<S.Background>
			<S.Wrapper>
				<Reversible>
					<div>
						<S.StyledChevronLeftBoldIcon onClick={props.goBack} />
					</div>
				</Reversible>
				{props.children}
				{props.cta || (
					<Components.CTAWrapper>
						<Button
							color="brand"
							testID="onboarding-next-button"
							text={$t('onboarding.buttons.next')}
							onClick={props.proceed}
						/>
					</Components.CTAWrapper>
				)}
			</S.Wrapper>
		</S.Background>
	);
};

namespace S {
	export const Background = styled.div`
		background-color: ${({ theme }) => theme.colors.decorativeMarketing};
		height: 100%;
		width: 100%;
	`;
	export const Wrapper = styled(Components.Wrapper)`
		background-color: ${({ theme }) => theme.colors.decorativeMarketing};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		position: relative;
		height: 100%;
		display: flex;
		justify-content: center;
		max-width: 400px;
		position: relative;
		margin: auto;
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			padding: ${({ theme }) => theme.spacings.xlarge} ${({ theme }) => theme.spacings.xsmall};
		}
	`;

	export const StyledChevronLeftBoldIcon = styled(ChevronLeftBoldIcon)`
		position: absolute;
		top: ${({ theme }) => theme.spacings.xlarge};
		left: ${({ theme }) => theme.spacings.xsmall};
		z-index: 5;
		border: 1px solid;
		border-radius: 100%;
		padding: 0.2em;
		height: 2em;
		width: 2em;
		cursor: pointer;

		${({ theme }) => theme.breakpoints.queries.above.mobile} {
			top: 5vh;
			left: -100px;
		}
	`;
}
